<template>
  <InvoiceParameterLabel :base="true" :textSm="textSm" :textLg="textLg">
    <slot></slot>
  </InvoiceParameterLabel>
</template>
<script>
import InvoiceParameterLabel from './InvoiceParameterLabel.vue';
export default {
  name: "InvoiceParameterText",
  components: {
    InvoiceParameterLabel,
  },
  props: {
    textSm: {
      type: Boolean,
      default: false,
    },
    textLg: {
      type: Boolean,
      default: false,
    },
  }
}
</script>